import { forwardRef } from "react";
import { MenuItem as MuiMenuItem } from "@mui/material";

import type { MenuItemProps as MuiMenuItemProps } from "@mui/material";

export interface MenuItemProps extends Omit<MuiMenuItemProps, "component"> {
  /** Compact density. Centro's default is Standard. Default: `false` */
  dense?: boolean;
  /** Root test id. Default: `"ds-menu-item"` */
  "data-testid"?: string;
}

/**
 * A Centro menu item. Standard density by default; hover, selected, and disabled
 * states come from the theme. Compose icon items with `ListItemIcon` +
 * `ListItemText`.
 */
export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(
  (
    {
      dense = false,
      "data-testid": dataTestId = "ds-menu-item",
      children,
      ...rest
    },
    ref,
  ) => (
    <MuiMenuItem {...rest} ref={ref} dense={dense} data-testid={dataTestId}>
      {children}
    </MuiMenuItem>
  ),
);

MenuItem.displayName = "MenuItem";
